// eslint-disable-next-line import/prefer-default-export
export const EmployeeReportType = Object.freeze({
    None: 0,
    EmployeeChoices: 1,
    UnawardedShiftlines: 2,
    EmployeeRanks: 3,
    EmployeeBiddingResults: 4,
});
